import { takeEvery, call, put, select } from 'typed-redux-saga'
import { errorHandler, gridSlice } from 'Modules'
import { RequestParams, ResponseCatalog } from 'Models'
import { BlockNS, blockApi, BlockModel, blockSlice, blockSelector } from 'Pages/orders'

function* getAll(action: BlockNS.GetAll) {
	try {
		yield* put(gridSlice.actions.setLoading(true))
		const { params, clear } = action.payload
		const { page, per_page, query, ...fields } = params
		const requestParams = new RequestParams(clear ? 1 : page, per_page, query, fields)
		if (clear) {
			yield* put(blockSlice.actions.clearAll())
		}
		const res = yield* call(blockApi.getAll, requestParams)
		const blocks = new ResponseCatalog<BlockModel>(res)
		if (!clear) {
			const oldBlocks = yield* select(blockSelector.getBlocks)
			blocks.entries = oldBlocks.concat(res.entries)
		}
		yield* put(blockSlice.actions.setAll(blocks))
		yield* put(blockSlice.actions.setParams(requestParams))
	} catch (error) {
		yield* call(errorHandler, error)
	} finally {
		yield* put(gridSlice.actions.setLoading(false))
	}
}

function* deleteOne(action: BlockNS.DeleteOne) {
	try {
		yield* call(blockApi.deleteOne, action.payload)
		const requestParams = yield* select(blockSelector.getParams)
		const blocks = yield* call(blockApi.getAll, requestParams)
		yield* put(blockSlice.actions.setAll(blocks))
	} catch (error) {
		yield* call(errorHandler, error)
	}
}

export const blockSaga = function* saga() {
	yield* takeEvery(blockSlice.actions.getAll.type, getAll)
	yield* takeEvery(blockSlice.actions.deleteOne.type, deleteOne)
}
